import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const BARRIER_DEVICE: AppRouteRecordRaw = {
  path: '/barrier-device',
  name: 'barrier-device',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '自有道闸管理',
    icon: 'icon-safe',
    requiresAuth: true,
    order: 9,
  },
  children: [
    {
      path: 'index',
      name: 'BarrierDeviceManagement',
      component: () => import('@/views/barrier-device/index.vue'),
      meta: {
        locale: '自有道闸管理',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default BARRIER_DEVICE;
